import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="w-full bg-warm-dark-alt py-20 md:py-28 relative overflow-hidden" data-id="element-122">
      <div className="absolute inset-0 bg-gradient-to-b from-warm-dark via-transparent to-warm-dark pointer-events-none opacity-40" data-id="element-123" />

      <div className="relative z-10 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="text-center" data-id="element-125">
          {/* Decorative line */}
          <div className="w-16 h-[2px] bg-amber/40 mx-auto mb-10" data-id="element-126" />

          <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold text-cream leading-snug mb-8" data-id="element-127">
            ¿Te has sentido alguna vez{' '}
            <span className="text-amber italic" data-id="element-128">
              atrapado en un ciclo de desánimo?
            </span>
          </h2>

          <p className="font-body text-cream-muted/70 text-base sm:text-lg leading-relaxed mb-8" data-id="element-129">
            ¿Notas que tu confianza se ha desvanecido con el tiempo y no
            encuentras una salida clara?
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: 'easeOut'
      }} className="mt-12" data-id="element-130">
          <div className="relative bg-warm-dark/60 border border-warm-border rounded-2xl p-8 sm:p-10 md:p-12" data-id="element-131">
            {/* Subtle amber accent on the left */}
            <div className="absolute left-0 top-8 bottom-8 w-[3px] bg-gradient-to-b from-amber/60 via-sunset/40 to-transparent rounded-full" data-id="element-132" />

            <p className="font-body text-cream-muted/85 text-base sm:text-lg leading-relaxed pl-4 sm:pl-6" data-id="element-133">
              Piensa en esos días en que te sientes sin energía, con dudas
              constantes sobre ti mismo y con ese peso invisible de la ansiedad.
              Ahora imagina seguir así durante semanas, meses o incluso años.{' '}
              <span className="text-cream font-medium" data-id="element-134">
                Esa espiral descendente puede afectar tu salud, tus relaciones y
                tu capacidad para avanzar.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}